export const initial = {
    price: null,
    submitting: false,
    subscription: null,
    type: null,
};

export function error(state, payload) {
    return { ...state, error: payload };
}

export function price(state, payload) {
    return { ...state, price: payload };
}

export function submitting(state, payload) {
    return { ...state, submitting: payload };
}

export function subscription(state, payload) {
    return { ...state, subscription: payload };
}

export function type(state, payload) {
    return { ...state, type: payload };
}

export function teeup(state, payload) {
    return {...state, teeup: payload };
}

export function submit(state, payload) {
    return {...state, form: payload };
}



// WEBPACK FOOTER //
// ./app/reducers/product.js